import { render, staticRenderFns } from "./eventPolling.vue?vue&type=template&id=00476d34&scoped=true"
import script from "./eventPolling.vue?vue&type=script&lang=js"
export * from "./eventPolling.vue?vue&type=script&lang=js"
import style0 from "./eventPolling.vue?vue&type=style&index=0&id=00476d34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00476d34",
  null
  
)

export default component.exports